import { render } from "./cookiepolicy.vue?vue&type=template&id=064f3e4a&scoped=true"
import script from "./cookiepolicy.vue?vue&type=script&lang=js"
export * from "./cookiepolicy.vue?vue&type=script&lang=js"

import "./cookiepolicy.vue?vue&type=style&index=0&id=064f3e4a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064f3e4a"]])

export default __exports__